import type { Object3D, PerspectiveCamera } from 'three'
import { Mesh } from 'three'

// Given a camera and an object size, find the minimum distance to view the entire object.
// LEGACY - Moved function into scene-view-resource.ts
export function getObjectFitDistance(camera: PerspectiveCamera, maxSize: number): number {
  const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * camera.fov) / 360))
  const fitWidthDistance = fitHeightDistance / camera.aspect

  return Math.max(fitHeightDistance, fitWidthDistance)
}

export const disposeNode = (node: Object3D) => {
  if (node instanceof Mesh) {
    const { geometry } = node
    geometry.dispose()
    disposeMaterial(node)
  }
}

export const disposeMaterial = (node: Object3D) => {
  if (node instanceof Mesh) {
    const { material } = node
    material.dispose()

    // Textures have to also be disposed of
    // These are the texture properties for MeshBasicMaterial and MeshStandardMaterial
    material.alphaMap?.dispose()
    material.aoMap?.dispose()
    material.bumpMap?.dispose()
    material.displacementMap?.dispose()
    material.emissiveMap?.dispose()
    material.envMap?.dispose()
    material.lightMap?.dispose()
    material.map?.dispose()
    material.metalnessMap?.dispose()
    material.normalMap?.dispose()
    material.roughnessMap?.dispose()
    material.specularMap?.dispose()
  }
}

export const disposeScene = (scene: Object3D) => {
  scene.traverse(child => disposeNode(child))
  // disposeHighlights()
  // renderer.renderLists.dispose()
}
